// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MoviesDataTableController from "./movies_data_table_controller"
application.register("movies-data-table", MoviesDataTableController)

import SeriesDataTableController from "./series_data_table_controller"
application.register("series-data-table", SeriesDataTableController)

import SetupTotpController from "./setup_totp_controller"
application.register("setup-totp", SetupTotpController)

import AccountFormController from "./account_form_controller"
application.register("account-form", AccountFormController)

import TotpVerificationController from "./totp_verification_controller"
application.register("totp-verification", TotpVerificationController)

import AdminsDataTableController from "./admins_data_table_controller"
application.register("admins-data-table", AdminsDataTableController)

import AccountsDataTableController from "./accounts_data_table_controller"
application.register("accounts-data-table", AccountsDataTableController)

import AccountToggleController from "./account_toggle_controller"
application.register("account-toggle", AccountToggleController)

import TotpToggleController from "./totp_toggle_controller"
application.register("totp-toggle", TotpToggleController)

import TotpVerificationModalController from "./totp_verification_modal_controller"
application.register("totp-verification-modal", TotpVerificationModalController)

import AdminFormController from "./admin_form_controller"
application.register("admin-form", AdminFormController)

import ProfileFormController from "./profile_form_controller"
application.register("profile-form", ProfileFormController)

import SeriesInfoController from "./series_info_controller"
application.register("series-info", SeriesInfoController)

import EpisodeInfoController from "./episode_info_controller"
application.register("episode-info", EpisodeInfoController)

import SeasonInfoController from "./season_info_controller"
application.register("season-info", SeasonInfoController)

import MovieFormController from "./movie_form_controller"
application.register("movie-form", MovieFormController)

import SeriesFormController from "./series_form_controller"
application.register("series-form", SeriesFormController)

import SeasonFormController from "./season_form_controller"
application.register("season-form", SeasonFormController)

import EpisodeFormController from "./episode_form_controller"
application.register("episode-form", EpisodeFormController)